import { createSlice } from "@reduxjs/toolkit";

type State = {
  errorObj: any;
}

const initialState: State = {
  errorObj: undefined
}

const errorReducer = createSlice({
  name: "error",
  initialState,
  reducers: {
    reset: () => initialState,
    initialize: (state) => {
      state.errorObj = initialState.errorObj
    },
    setErrorObj: (state, action) => {
      state.errorObj = action.payload
    }
  }
});

export const {
  reset,
  initialize,
  setErrorObj,
} = errorReducer.actions;

export default errorReducer.reducer;
